import { Hero, Page } from '@hbo/ui-servicing-react-components';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const ServerError: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('serverError.tabTitle')}</title>
      </Helmet>
      <Hero>
        <Hero.PrimaryContent title={t('serverError.title')} />
      </Hero>
      <Page>
        <Page.Content>
          <p>{t('serverError.text', { appName: t('app.name') })}</p>
        </Page.Content>
      </Page>
    </>
  );
};

export default ServerError;
